export default {
  language: '語言',
  contactUs: '聯絡我們',
  officialWebsite: 'TokenPocket官網',
  twitter: '推特',
  telegram: 'Telegram',
  connectWallet: '連接錢包',
  connectTPWallet: '1. 連接TokenPocket',
  addZetaChain: '2. 自訂添加ZetaChain測試網',
  ZETAAmount: '3. 領取ZetaChain測試幣:',
  start: '開始',
  verify: '驗證',
  Verified: '已驗證',
  tutorial: '教學',
  more: '更多',
  close: '收起',
  discoverMore: '在#TokenPocketChristmas探索更多驚喜！',
  getTestnetZETA: '領取 $ZETA 測試幣',
  switchWallet: '請先在錢包切換到EVM錢包',
  modal: {
    title: '連接TokenPocket',
    desc: '您的Web3錢包',
    text_1: '安裝TokenPocket插件到Chrome瀏覽器。',
    text_2: '下載TokenPocket應用程式。',
    text_3: '手機掃描二維碼進入TokenPocket官網下載。',
    text_4: 'INJECTED',
  },

  activity_text_1: '1. 完成社交任務',
  activity_text_2: '根據Galxe指引完成社交任務。',
  activity_1_1: 'TokenPocket',
  activity_1_2:
    'TokenPocket是全球領先的多鏈自託管錢包，支援BTC、ETH、BSC、TRON、DOGE、ZetaChain、Polygon、Arbitrum, Optimism, Solana、HECO、Klaytn、Avalanche、OKC、Fantom、Polkadot、Kusama等主流公鏈。',

  activity_2_1: 'ZetaSwap',
  activity_2_2:
    'ZetaSwap 是 ZetaChain 上第一個原生支援的PMM，讓使用者可以輕鬆有效率地在 ZetaChain 網路上兌換資產。 ZetaSwap 確保您在使用 ZetaChain 時獲得深度流動性、最便宜的成本和用戶友好的體驗。',
  activity_2_5: '2. 在ZetaSwap上交易。',
  activity_2_6: '體驗zetaETH兌換zetaBTC或zetaBTC兌換zetaETH。',

  activity_3_1: 'Eddy Finance',
  activity_3_2:
    'Eddy Finance是基於ZetaChain的全鏈去中心化交易所（DEX），透過無與倫比的速度和成本效益簡化了跨網路的原生資產轉移，而無需進行任何包裝。 Eddy的跨鏈統一流動性池結合了包括ETH、BTC、BNB和穩定幣在內的原生資產，以優化效率。 Eddy透過將BTC無縫整合到以太坊虛擬機器（EVM）生態系統中，進一步增強了BTC，在DeFi領域開啟了新的視野。',
  activity_3_5: '2. 在Eddy Finance上交易。',
  activity_3_6: '在Eddy Finance交易任意两个代币。',

  activity_4_1: 'LENX',
  activity_4_2:
    'LENX是專注於比特幣的借貸協議。 透過利用經過時間驗證的協議，如Aave和Compound，您可以存款和借貸資產，以獲得最佳利率。',
  activity_4_5: '2. 在Discord領取測試網代幣。',
  activity_4_6: '你可以在LENX的Discord領取測試網上的BTC和ETH。',
  activity_4_7: '3. 在LENX上體驗借貸/存款。',
  activity_4_8: '在LENX借出任一數量的BTC測試幣後，存入ETH。',

  activity_5_1: 'zkMe',
  activity_5_2:
    'zkMe 是一個去中心化 Web3 憑證網絡，利用零知識證明、多方安全運算及機器學習技術來增強去中心化身分的隱私和安全。',
  activity_5_5: '2. 鑄造專屬Omni NFT。',
  activity_5_6: '在zkMe上繪製聖誕標誌並鑄造專屬Omni NFT。',

  activity_6_1: 'Ultiverse ',
  activity_6_2:
    'Ultiverse的目標是將MetaFi變為現實，並創建一個提供用戶多種不同體驗的Web3遊戲和元宇宙平台。 他們利用MetaFi和先進的去中心化應用程式（Dapps）來建立一個包容所有人的社區。 憑藉超過2,000萬美元的資金，Ultiverse的生態系統是一個充滿活力和互動性的地方，激發人們的創造力並勇於探索。',
  activity_6_5: '2. 鑄造一個 Meta Merge Match 3 NFT。',
  activity_6_6: '贏得第一輪遊戲的勝利並鑄造你的 Meta Merge Match 3 NFT。',

  activity_7_1: 'Sushi',
  activity_7_2:
    'Sushi是一家領先的多鏈去中心化交易所（DEX），部署在30多個鏈上，並透過SushiXSwap提供獨特的跨鏈交換服務。 專注於提供無縫的用戶體驗、創新的交易和增強的流動性提供，Sushi致力於成為一個由社區構建、開源的DeFi工俱生態系統，涵蓋您所需的所有工具。',

  activity_8_1: 'Suger',
  activity_8_2: '一個Web3約會應用程序，提升人與人之間的連接，不僅僅是浪漫。',
  activity_8_5: '2. 領取免費Suger Pass卡。',
  activity_8_6: '在Suger上領取Suger Pass卡並加入Suger白名單。',

  activity_9_1: 'ChatGM',
  activity_9_2:
    'ChatGM使用互動式AI讓web3簡單易用。 ChatGM將EVM/BTC錢包作為數位id，提供跨加密錢包、Telegram、WhatsApp的加密簡訊、語音、視訊通話',
  activity_9_5: '2. 造訪ChatGM官網並註冊一個ChatGM帳號。',
  activity_9_6: '造訪ChatGM官網並提供郵箱/錢包註冊一個ChatGM帳號來獲得未來的空投和積分。',
  activity_9_7: '3. 領取POAP。',
  activity_9_8: '在Galxe鑄造你的OAT，該OAT將作為ChatGM的 OG POAP。',

  activity_10_1: 'CharacterX',
  activity_10_2:
    'CharacterX是一個分散的合成社交網絡，使用者和人工智慧代理商可以在其中進行互動、創建、投資和賺錢。 它旨在透過創新的人工智慧NFT機制，為創造者、消費者、人工智慧代理商和投資者提供永續的經濟。 先進的多模式技術，包括語音、視覺和3D AR，大大增加了使用者體驗。',
  activity_10_5: '2. 創建AI角色並鑄造NFT。',
  activity_10_6: '創建你的 AI 角色並鑄造Soul Pass NFT。',
};
